import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, useTranslations } from "@jti/ui";
import SecureCard from "./secureCard.svg";
import styles from "./PaymentPageSecureBlock.module.scss";
export const PaymentPageSecureBlock = () => {
    const { __ } = useTranslations();
    return (_jsxs("div", { "data-testid": "secureBlock", children: [_jsxs("div", { className: styles.secureImg, children: [_jsx(Icon, { component: SecureCard, width: "33px", height: "22px" }), _jsx("span", { children: __("cart.checkout.payment.secure_payment.title") })] }), _jsx("div", { className: styles.secureTxt, children: __("cart.checkout.payment.secure_payment.text") })] }));
};
//# sourceMappingURL=PaymentPageSecureBlock.js.map